<svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Map marker</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <filter id="f3" x="0" y="0" width="200%" height="200%">
            <feOffset result="offOut" in="SourceAlpha" dx="20" dy="20" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
    </defs>
    <g id="Pin-Schule" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group">
            <circle class="shadow" id="Oval-Copy" fill="#EAEAEA" cx="26" cy="26" r="24"></circle>
            <circle class="primary selected-white" id="Oval" fill="#FFFFFF" cx="26" cy="26" r="23"></circle>
            <circle class="white selected-primary" id="Oval" fill="#FFFFFF" cx="26" cy="26" r="21"></circle>
        </g>
    </g>
</svg>
